// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signUpPage .signUpPage__main {
  display: flex;
  justify-content: space-between;
  min-height: 100vh;
}
@media (max-width: 1279px) {
  .signUpPage .signUpPage__main {
    flex-direction: column;
  }
}
.signUpPage .signUpPage__main .signUpPage__left {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 50%;
  height: 100vh;
  background-color: #fbfaff;
  padding: 4%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 0;
  overflow: auto;
}
@media (max-width: 1279px) {
  .signUpPage .signUpPage__main .signUpPage__left {
    width: 100%;
    min-height: 50vh;
  }
}
@media (max-width: 767px) {
  .signUpPage .signUpPage__main .signUpPage__left {
    padding: 4rem 2rem 2rem;
  }
}
.signUpPage .signUpPage__main .signUpPage__left .signUpPage__backButton {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: absolute;
  top: 1rem;
  left: 4%;
}
.signUpPage .signUpPage__main .signUpPage__left .signUpPage__backButton a {
  display: flex;
  align-items: center;
  justify-content: center;
}
.signUpPage .signUpPage__main .signUpPage__left .signUpPage__backButton a i {
  font-size: 1rem;
  color: #191a1a;
  margin-right: 0.25rem;
}
.signUpPage .signUpPage__main .signUpPage__left .signUpPage__backButton a span {
  display: inline-block;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1;
  color: #191a1a;
}
.signUpPage .signUpPage__main .signUpPage__left .signUpPage__slider {
  width: 100%;
  background-color: #2056a5;
  border-radius: 0.5rem;
  padding: 1rem 0 0;
}
@media (max-width: 1279px) {
  .signUpPage .signUpPage__main .signUpPage__left .signUpPage__slider {
    width: 60%;
  }
}
@media (max-width: 767px) {
  .signUpPage .signUpPage__main .signUpPage__left .signUpPage__slider {
    width: 100%;
  }
}
.signUpPage .signUpPage__main .signUpPage__left .signUpPage__slider * {
  outline: none !important;
}
.signUpPage .signUpPage__main .signUpPage__left .signUpPage__slider--forgetPassword .slick-slider {
  padding: 0 !important;
}
.signUpPage .signUpPage__main .signUpPage__left .signUpPage__slider .slick-slider {
  padding: 0 0 1rem;
}
.signUpPage .signUpPage__main .signUpPage__left .signUpPage__slider .signUpPage__box {
  padding: 0 1rem 1rem;
}
.signUpPage .signUpPage__main .signUpPage__left .signUpPage__slider .signUpPage__box h4 {
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.4;
  color: white;
  margin: 0 0 0.5rem;
  text-transform: uppercase;
}
.signUpPage .signUpPage__main .signUpPage__left .signUpPage__slider .signUpPage__box h2 {
  font-size: 1.6rem;
  font-weight: 800;
  line-height: 1.4;
  color: white;
  margin: 0 0 0.5rem;
}
.signUpPage .signUpPage__main .signUpPage__left .signUpPage__slider .signUpPage__box p {
  font-size: 0.65rem;
  font-weight: 400;
  line-height: 1.5;
  color: white;
  margin: 0;
}
.signUpPage .signUpPage__main .signUpPage__left .signUpPage__slider .signUpPage__box figure {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 0 auto;
  width: 58.4%;
}
.signUpPage .signUpPage__main .signUpPage__left .signUpPage__slider .signUpPage__box figure img {
  width: auto;
}
.signUpPage .signUpPage__main .signUpPage__left .signUpPage__slider .slick-dots {
  display: flex !important;
  align-items: center;
  justify-content: center;
  bottom: 1.25rem;
}
.signUpPage .signUpPage__main .signUpPage__left .signUpPage__slider .slick-dots li {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 0.6rem;
  height: 0.6rem;
  margin: 0;
  margin-right: 0.5rem;
}
.signUpPage .signUpPage__main .signUpPage__left .signUpPage__slider .slick-dots li:last-child {
  margin: 0;
}
.signUpPage .signUpPage__main .signUpPage__left .signUpPage__slider .slick-dots li button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 0.6rem;
  height: 0.6rem;
  padding: 0;
  margin: 0;
  border-radius: 0.6rem;
  background-color: rgba(255, 255, 255, 0.46);
}
.signUpPage .signUpPage__main .signUpPage__left .signUpPage__slider .slick-dots li button::before {
  display: none;
}
.signUpPage .signUpPage__main .signUpPage__left .signUpPage__slider .slick-dots li.slick-active {
  width: 1.6rem;
}
.signUpPage .signUpPage__main .signUpPage__left .signUpPage__slider .slick-dots li.slick-active button {
  width: 1.6rem;
  background: #f38b3e;
}
.signUpPage .signUpPage__main .signUpPage__right {
  display: flex;
  flex-direction: column;
  width: 50%;
  height: 100vh;
  background-color: #f9f9f9;
  box-shadow: 0 0 1rem 0.25rem rgba(43, 28, 3, 0.1);
  padding: 4% calc(4% - 1.5rem);
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1;
  overflow: auto;
}
@media (max-width: 1279px) {
  .signUpPage .signUpPage__main .signUpPage__right {
    width: 100%;
    min-height: 50vh;
  }
}
@media (max-width: 767px) {
  .signUpPage .signUpPage__main .signUpPage__right {
    padding: 2rem;
  }
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__heading {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  width: 100%;
  margin: 0 0 2rem;
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__heading:last-child {
  margin: 0;
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__heading figure {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 25%;
  max-width: 10rem;
  margin: 0 auto;
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__heading figure img {
  width: 100%;
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__heading h1 {
  font-size: 1.7rem;
  font-weight: 700;
  line-height: 1.2;
  color: #191a1a;
  margin: 1rem 0 0;
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__heading h4 {
  font-size: 0.9rem;
  font-weight: 400;
  line-height: 1.5;
  color: #191a1a;
  margin: 1rem 0 0;
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__heading h4.thankyouHeading {
  display: block;
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__heading h4.thankyouHeading span {
  color: #84bd00;
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__heading h4.thankyouHeading span,
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__heading h4.thankyouHeading strong {
  display: block;
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__heading p {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 1rem 0 0;
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__heading p span {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  font-weight: 700;
  line-height: 1;
  color: #0f61dc;
  background-color: rgba(32, 86, 165, 0.12);
  border-radius: 1.5rem;
  padding: 0.75rem 3rem;
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__heading p span i {
  font-size: 1rem;
  margin-right: 0.5rem;
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__heading p a {
  display: inline-block;
  padding: 0.6rem 3rem;
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__heading p a i {
  margin-right: 0.5rem;
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__heading p button {
  display: inline-block;
  padding: 0.6rem 3rem;
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__heading p button i {
  margin-right: 0.5rem;
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__form {
  display: flex;
  flex-direction: column;
  width: 100%;
}
@media (max-width: 1279px) {
  .signUpPage .signUpPage__main .signUpPage__right .signUpPage__form {
    width: 60%;
    margin: 0 auto;
  }
}
@media (max-width: 767px) {
  .signUpPage .signUpPage__main .signUpPage__right .signUpPage__form {
    width: 100%;
  }
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__form .signUpPage__formSection {
  display: flex;
  flex-direction: column;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__form .signUpPage__formSection > .row > [class*=col-]:last-child .form-group {
  margin: 0;
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__form .signUpPage__formSection .form-group {
  margin: 0 0 1rem;
  position: relative;
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__form .signUpPage__formSection .form-group .css-qbdosj-Input {
  margin: 0;
  padding: 0;
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__form .signUpPage__formSection .form-group .css-13cymwt-control {
  border-radius: 0.375rem;
  min-height: 27px;
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__form .signUpPage__formSection .form-group .css-13cymwt-control .css-1xc3v61-indicatorContainer {
  padding: 0.215rem !important;
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__form .signUpPage__formSection .form-group .css-1jqq78o-placeholder {
  margin: 0;
  font-size: 0.8rem;
  color: #191a1a;
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__form .signUpPage__formSection .form-group .css-1fdsijx-ValueContainer {
  padding: 0.4rem 0.9rem !important;
  font-size: 1rem !important;
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .signUpPage .signUpPage__main .signUpPage__right .signUpPage__form .signUpPage__formSection .form-group .css-1fdsijx-ValueContainer {
    padding: 0.4rem 0.9rem !important;
    font-size: 0.8rem !important;
  }
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__form .signUpPage__formSection .form-group .css-1dimb5e-singleValue {
  font-size: 0.8rem;
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__form .signUpPage__formSection .form-group .css-t3ipsp-control {
  border-radius: 0.375rem;
  min-height: 27px;
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__form .signUpPage__formSection .form-group .css-t3ipsp-control .css-15lsz6c-indicatorContainer {
  padding: 0.215rem !important;
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__form .signUpPage__formSection .form-group.withIcon .form-control {
  padding: 0.6rem 0.9rem;
  border-radius: 0.375rem;
  padding-right: 2.5rem;
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__form .signUpPage__formSection .form-group.withIcon .passwordToggle {
  display: block;
  position: absolute;
  top: 1.2rem;
  right: 0.75rem;
  width: 1.25rem;
  transform: translateY(-50%);
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__form .signUpPage__formSection .form-group.withIcon .passwordToggle img {
  width: 100%;
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__form .signUpPage__formSection .form-group.withIcon--forgetPassword .form-control {
  border-radius: 0.375rem;
  padding: 0.6rem 0.9rem 0.6rem 0.6rem !important;
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__form .signUpPage__formSection .form-group.withIcon--forgetPassword .passwordToggle {
  display: block;
  position: absolute;
  top: 0.7rem;
  left: 0.75rem;
  width: 1.25rem;
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__form .signUpPage__formSection .form-group.withIcon--forgetPassword .passwordToggle img {
  width: 100%;
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__form .signUpPage__formSection .form-group label {
  font-size: 0.8rem;
  font-weight: 600;
  line-height: 1.5;
  color: #191a1a;
  margin: 0 0 0.5rem;
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__form .signUpPage__formSection .form-group .form-control {
  border-radius: 0.375rem;
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: 0.025rem;
  color: #191a1a;
  padding: 0.5rem 0.75rem;
  min-height: 2.25rem;
  background-color: #fafafa;
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__form .signUpPage__formSection .form-group .form-control::-webkit-input-placeholder {
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: 0.025rem;
  color: #191a1a;
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__form .signUpPage__formSection .form-group .form-control::-moz-placeholder {
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: 0.025rem;
  color: #191a1a;
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__form .signUpPage__formSection .form-group .form-control:-ms-input-placeholder {
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: 0.025rem;
  color: #191a1a;
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__form .signUpPage__formSection .form-group .form-control:-moz-placeholder {
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: 0.025rem;
  color: #191a1a;
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__form .signUpPage__formSection .form-group .form-control:focus {
  box-shadow: none;
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__form .signUpPage__formSection .form-group > p {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 0.8rem;
  font-weight: 600;
  line-height: 1.5;
  color: #191a1a;
  margin: 0;
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__form .signUpPage__formSection .form-group > p.text-end {
  justify-content: flex-end;
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__form .signUpPage__formSection .form-group > p input {
  margin: 0 0.5rem 0 0;
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__form .signUpPage__formSection .form-group > p a {
  display: inline-block;
  font-size: 0.8rem;
  font-weight: 600;
  line-height: 1.5;
  color: #2056a5;
  margin-left: 0.25rem;
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__form .signUpPage__formSection .form-group .signup_checklabel {
  display: flex;
  align-items: center;
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__form .signUpPage__formSection .form-group .signup_checklabel input {
  margin-right: 0.5rem;
  width: 20px;
  height: 20px;
}
.signUpPage .signUpPage__main .signUpPage__right .signUpPage__form .signUpPage__formSection .form-group .signup_checklabel p {
  margin-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/styles/authentication.scss"],"names":[],"mappings":"AA6BC;EACC,aAAA;EACA,8BAAA;EAEA,iBAAA;AA7BF;AA+BE;EAND;IAOE,sBAAA;EA5BD;AACF;AA8BE;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EAEA,UAAA;EACA,aAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,cAAA;AA7BH;AA+BG;EAhBD;IAiBE,WAAA;IACA,gBAAA;EA5BF;AACF;AA8BG;EArBD;IAsBE,uBAAA;EA3BF;AACF;AA6BG;EACC,aAAA;EACA,mBAAA;EACA,2BAAA;EAEA,kBAAA;EACA,SAAA;EACA,QAAA;AA5BJ;AA8BI;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;AA5BL;AA8BK;EACC,eAAA;EACA,cAAA;EACA,qBAAA;AA5BN;AA+BK;EACC,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AA7BN;AAkCG;EACC,WAAA;EACA,yBA1FY;EA2FZ,qBAAA;EACA,iBAAA;AAhCJ;AAkCI;EAND;IAOE,UAAA;EA/BH;AACF;AAiCI;EAVD;IAWE,WAAA;EA9BH;AACF;AAgCI;EACC,wBAAA;AA9BL;AAkCK;EACC,qBAAA;AAhCN;AAoCI;EACC,iBAAA;AAlCL;AAqCI;EAIC,oBAAA;AAtCL;AAwCK;EACC,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AAtCN;AAyCK;EACC,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AAvCN;AA0CK;EACC,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,SAAA;AAxCN;AA2CK;EACC,aAAA;EACA,mBAAA;EACA,2BAAA;EAEA,cAAA;EACA,YAAA;AA1CN;AA4CM;EACC,WAAA;AA1CP;AA+CI;EACC,wBAAA;EACA,mBAAA;EACA,uBAAA;EAEA,eAAA;AA9CL;AAgDK;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,aAAA;EACA,cAAA;EACA,SAAA;EACA,oBAAA;AA/CN;AAiDM;EACC,SAAA;AA/CP;AAkDM;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,aAAA;EACA,cAAA;EACA,UAAA;EACA,SAAA;EACA,qBAAA;EACA,2CAAA;AAjDP;AAmDO;EACC,aAAA;AAjDR;AAqDM;EACC,aAAA;AAnDP;AAqDO;EACC,aAAA;EACA,mBAAA;AAnDR;AA2DE;EACC,aAAA;EACA,sBAAA;EAEA,UAAA;EACA,aAAA;EACA,yBAAA;EACA,iDAAA;EACA,6BAAA;EACA,eAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,cAAA;AA1DH;AA4DG;EAfD;IAgBE,WAAA;IACA,gBAAA;EAzDF;AACF;AA2DG;EApBD;IAqBE,aAAA;EAxDF;AACF;AA0DG;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EAEA,kBAAA;EACA,WAAA;EACA,gBAAA;AAzDJ;AA2DI;EACC,SAAA;AAzDL;AA4DI;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,UAAA;EACA,gBAAA;EACA,cAAA;AA3DL;AA6DK;EACC,WAAA;AA3DN;AA+DI;EACC,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AA7DL;AAgEI;EACC,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AA9DL;AAgEK;EACC,cAAA;AA9DN;AAgEM;EACC,cAAA;AA9DP;AAiEM;;EAEC,cAAA;AA/DP;AAoEI;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,gBAAA;AAnEL;AAqEK;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,yCAAA;EACA,qBAAA;EACA,qBAAA;AApEN;AAsEM;EACC,eAAA;EACA,oBAAA;AApEP;AAwEK;EACC,qBAAA;EACA,oBAAA;AAtEN;AAwEM;EACC,oBAAA;AAtEP;AA0EK;EACC,qBAAA;EACA,oBAAA;AAxEN;AA0EM;EACC,oBAAA;AAxEP;AA8EG;EACC,aAAA;EACA,sBAAA;EAEA,WAAA;AA7EJ;AA+EI;EAND;IAOE,UAAA;IACA,cAAA;EA5EH;AACF;AA8EI;EAXD;IAYE,WAAA;EA3EH;AACF;AA6EI;EACC,aAAA;EACA,sBAAA;EAEA,qBAAA;EACA,sBAAA;AA5EL;AAiFQ;EACC,SAAA;AA/ET;AAqFK;EACC,gBAAA;EACA,kBAAA;AAnFN;AAqFM;EAAkB,SAAA;EAAU,UAAA;AAjFlC;AAkFM;EACC,uBAAA;EAAwB,gBAAA;AA/E/B;AAiFO;EAAgC,4BAAA;AA9EvC;AAgFM;EAAyB,SAAA;EAAU,iBAAA;EAAkB,cAAA;AA3E3D;AA4EM;EAA4B,iCAAA;EAAkC,0BAAA;AAxEpE;AAyEM;EACC;IAA4B,iCAAA;IAAkC,4BAAA;EArEnE;AACF;AAsEM;EAAyB,iBAAA;AAnE/B;AAoEM;EACC,uBAAA;EAAwB,gBAAA;AAjE/B;AAmEO;EAAgC,4BAAA;AAhEvC;AAsEO;EACC,sBAAA;EACA,uBAAA;EACA,qBAAA;AApER;AAuEO;EACC,cAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,cAAA;EACA,2BAAA;AArER;AAuEQ;EACC,WAAA;AArET;AA0EQ;EACC,uBAAA;EACA,+CAAA;AAxET;AA4EQ;EACC,cAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;AA1ET;AA4ES;EACC,WAAA;AA1EV;AAgFM;EACC,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AA9EP;AAiFM;EACC,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,wBAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAncW;AAoXlB;AAiFO;EACC,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,wBAAA;EACA,cAAA;AA/ER;AAkFO;EACC,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,wBAAA;EACA,cAAA;AAhFR;AAmFO;EACC,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,wBAAA;EACA,cAAA;AAjFR;AAoFO;EACC,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,wBAAA;EACA,cAAA;AAlFR;AAqFO;EACC,gBAAA;AAnFR;AAuFM;EACC,aAAA;EACA,mBAAA;EACA,2BAAA;EAEA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AAtFP;AAwFO;EACC,yBAAA;AAtFR;AAyFO;EACC,oBAAA;AAvFR;AA0FO;EACC,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cApgBQ;EAqgBR,oBAAA;AAxFR;AA4IM;EACC,aAAA;EACA,mBAAA;AA1IP;AA4IO;EACC,oBAAA;EACA,WAAA;EACA,YAAA;AA1IR;AA6IO;EACC,gBAAA;AA3IR","sourcesContent":["///* ----------- Default Styling Start --------------- */\r\n\r\n$primary-fontFamily: \"Montserrat\", sans-serif;\r\n$primary-fontWeight: 400;\r\n$primary-lineHeight: 1.4;\r\n$primary-fontColor: #6e6b7b;\r\n$primary-color: #2056a5;\r\n$primary-hover: #1b427c;\r\n$primary-bgColor: #fafafa;\r\n$color-black: #000000;\r\n$color-white: #ffffff;\r\n\r\n/// Viewport\r\n$desktop_xxxl: 1920px;\r\n$desktop_xxl: 1650px;\r\n$desktop_xl: 1440px;\r\n$laptop: 1366px;\r\n$desktop: 1280px;\r\n$desktopSmall: 1024px;\r\n$tabletSmall: 768px;\r\n$mobileBig: 767px;\r\n$mobile: 480px;\r\n$mobileSmall: 360px;\r\n\r\n///* ----------- Default Styling End ----------------- */\r\n\r\n.signUpPage {\r\n\t$signUpPage: \".signUpPage\";\r\n\r\n\t#{$signUpPage}__main {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: space-between;\r\n\r\n\t\tmin-height: 100vh;\r\n\r\n\t\t@media (max-width: $desktop - 1) {\r\n\t\t\tflex-direction: column;\r\n\t\t}\r\n\r\n\t\t#{$signUpPage}__left {\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tjustify-content: center;\r\n\t\t\tflex-direction: column;\r\n\r\n\t\t\twidth: 50%;\r\n\t\t\theight: 100vh;\r\n\t\t\tbackground-color: #fbfaff;\r\n\t\t\tpadding: 4%;\r\n\t\t\tposition: fixed;\r\n\t\t\ttop: 0;\r\n\t\t\tleft: 0;\r\n\t\t\tz-index: 0;\r\n\t\t\toverflow: auto;\r\n\r\n\t\t\t@media (max-width: $desktop - 1) {\r\n\t\t\t\twidth: 100%;\r\n\t\t\t\tmin-height: 50vh;\r\n\t\t\t}\r\n\r\n\t\t\t@media (max-width: $mobileBig) {\r\n\t\t\t\tpadding: 4rem 2rem 2rem;\r\n\t\t\t}\r\n\r\n\t\t\t#{$signUpPage}__backButton {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tjustify-content: flex-start;\r\n\r\n\t\t\t\tposition: absolute;\r\n\t\t\t\ttop: 1rem;\r\n\t\t\t\tleft: 4%;\r\n\r\n\t\t\t\ta {\r\n\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\talign-items: center;\r\n\t\t\t\t\tjustify-content: center;\r\n\r\n\t\t\t\t\ti {\r\n\t\t\t\t\t\tfont-size: 1rem;\r\n\t\t\t\t\t\tcolor: #191a1a;\r\n\t\t\t\t\t\tmargin-right: 0.25rem;\r\n\t\t\t\t\t}\r\n\r\n\t\t\t\t\tspan {\r\n\t\t\t\t\t\tdisplay: inline-block;\r\n\t\t\t\t\t\tfont-size: 1rem;\r\n\t\t\t\t\t\tfont-weight: 600;\r\n\t\t\t\t\t\tline-height: 1;\r\n\t\t\t\t\t\tcolor: #191a1a;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t#{$signUpPage}__slider {\r\n\t\t\t\twidth: 100%;\r\n\t\t\t\tbackground-color: $primary-color;\r\n\t\t\t\tborder-radius: 0.5rem;\r\n\t\t\t\tpadding: 1rem 0 0;\r\n\r\n\t\t\t\t@media (max-width: $desktop - 1) {\r\n\t\t\t\t\twidth: 60%;\r\n\t\t\t\t}\r\n\r\n\t\t\t\t@media (max-width: $mobileBig) {\r\n\t\t\t\t\twidth: 100%;\r\n\t\t\t\t}\r\n\r\n\t\t\t\t* {\r\n\t\t\t\t\toutline: none !important;\r\n\t\t\t\t}\r\n\r\n\t\t\t\t&--forgetPassword {\r\n\t\t\t\t\t.slick-slider {\r\n\t\t\t\t\t\tpadding: 0 !important;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\r\n\t\t\t\t.slick-slider {\r\n\t\t\t\t\tpadding: 0 0 1rem;\r\n\t\t\t\t}\r\n\r\n\t\t\t\t#{$signUpPage}__box {\r\n\t\t\t\t\t// display: flex;\r\n\t\t\t\t\t// align-items: flex-start;\r\n\r\n\t\t\t\t\tpadding: 0 1rem 1rem;\r\n\r\n\t\t\t\t\th4 {\r\n\t\t\t\t\t\tfont-size: 1rem;\r\n\t\t\t\t\t\tfont-weight: 500;\r\n\t\t\t\t\t\tline-height: 1.4;\r\n\t\t\t\t\t\tcolor: white;\r\n\t\t\t\t\t\tmargin: 0 0 0.5rem;\r\n\t\t\t\t\t\ttext-transform: uppercase;\r\n\t\t\t\t\t}\r\n\r\n\t\t\t\t\th2 {\r\n\t\t\t\t\t\tfont-size: 1.6rem;\r\n\t\t\t\t\t\tfont-weight: 800;\r\n\t\t\t\t\t\tline-height: 1.4;\r\n\t\t\t\t\t\tcolor: white;\r\n\t\t\t\t\t\tmargin: 0 0 0.5rem;\r\n\t\t\t\t\t}\r\n\r\n\t\t\t\t\tp {\r\n\t\t\t\t\t\tfont-size: 0.65rem;\r\n\t\t\t\t\t\tfont-weight: 400;\r\n\t\t\t\t\t\tline-height: 1.5;\r\n\t\t\t\t\t\tcolor: white;\r\n\t\t\t\t\t\tmargin: 0;\r\n\t\t\t\t\t}\r\n\r\n\t\t\t\t\tfigure {\r\n\t\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\t\talign-items: center;\r\n\t\t\t\t\t\tjustify-content: flex-start;\r\n\r\n\t\t\t\t\t\tmargin: 0 auto;\r\n\t\t\t\t\t\twidth: 58.4%;\r\n\r\n\t\t\t\t\t\timg {\r\n\t\t\t\t\t\t\twidth: auto;\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\r\n\t\t\t\t.slick-dots {\r\n\t\t\t\t\tdisplay: flex !important;\r\n\t\t\t\t\talign-items: center;\r\n\t\t\t\t\tjustify-content: center;\r\n\r\n\t\t\t\t\tbottom: 1.25rem;\r\n\r\n\t\t\t\t\tli {\r\n\t\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\t\talign-items: center;\r\n\t\t\t\t\t\tjustify-content: center;\r\n\r\n\t\t\t\t\t\twidth: 0.6rem;\r\n\t\t\t\t\t\theight: 0.6rem;\r\n\t\t\t\t\t\tmargin: 0;\r\n\t\t\t\t\t\tmargin-right: 0.5rem;\r\n\r\n\t\t\t\t\t\t&:last-child {\r\n\t\t\t\t\t\t\tmargin: 0;\r\n\t\t\t\t\t\t}\r\n\r\n\t\t\t\t\t\tbutton {\r\n\t\t\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\t\t\talign-items: center;\r\n\t\t\t\t\t\t\tjustify-content: center;\r\n\r\n\t\t\t\t\t\t\twidth: 0.6rem;\r\n\t\t\t\t\t\t\theight: 0.6rem;\r\n\t\t\t\t\t\t\tpadding: 0;\r\n\t\t\t\t\t\t\tmargin: 0;\r\n\t\t\t\t\t\t\tborder-radius: 0.6rem;\r\n\t\t\t\t\t\t\tbackground-color: rgba($color-white, 0.46);\r\n\r\n\t\t\t\t\t\t\t&::before {\r\n\t\t\t\t\t\t\t\tdisplay: none;\r\n\t\t\t\t\t\t\t}\r\n\t\t\t\t\t\t}\r\n\r\n\t\t\t\t\t\t&.slick-active {\r\n\t\t\t\t\t\t\twidth: 1.6rem;\r\n\r\n\t\t\t\t\t\t\tbutton {\r\n\t\t\t\t\t\t\t\twidth: 1.6rem;\r\n\t\t\t\t\t\t\t\tbackground: #f38b3e;\r\n\t\t\t\t\t\t\t}\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t#{$signUpPage}__right {\r\n\t\t\tdisplay: flex;\r\n\t\t\tflex-direction: column;\r\n\r\n\t\t\twidth: 50%;\r\n\t\t\theight: 100vh;\r\n\t\t\tbackground-color: #f9f9f9;\r\n\t\t\tbox-shadow: 0 0 1rem 0.25rem rgba(#2b1c03, 0.1);\r\n\t\t\tpadding: 4% calc(4% - 1.5rem);\r\n\t\t\tposition: fixed;\r\n\t\t\ttop: 0;\r\n\t\t\tright: 0;\r\n\t\t\tz-index: 1;\r\n\t\t\toverflow: auto;\r\n\r\n\t\t\t@media (max-width: $desktop - 1) {\r\n\t\t\t\twidth: 100%;\r\n\t\t\t\tmin-height: 50vh;\r\n\t\t\t}\r\n\r\n\t\t\t@media (max-width: $mobileBig) {\r\n\t\t\t\tpadding: 2rem;\r\n\t\t\t}\r\n\r\n\t\t\t#{$signUpPage}__heading {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tjustify-content: center;\r\n\t\t\t\tflex-direction: column;\r\n\r\n\t\t\t\ttext-align: center;\r\n\t\t\t\twidth: 100%;\r\n\t\t\t\tmargin: 0 0 2rem;\r\n\r\n\t\t\t\t&:last-child {\r\n\t\t\t\t\tmargin: 0;\r\n\t\t\t\t}\r\n\r\n\t\t\t\tfigure {\r\n\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\talign-items: center;\r\n\t\t\t\t\tjustify-content: center;\r\n\r\n\t\t\t\t\twidth: 25%;\r\n\t\t\t\t\tmax-width: 10rem;\r\n\t\t\t\t\tmargin: 0 auto;\r\n\r\n\t\t\t\t\timg {\r\n\t\t\t\t\t\twidth: 100%;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\r\n\t\t\t\th1 {\r\n\t\t\t\t\tfont-size: 1.7rem;\r\n\t\t\t\t\tfont-weight: 700;\r\n\t\t\t\t\tline-height: 1.2;\r\n\t\t\t\t\tcolor: #191a1a;\r\n\t\t\t\t\tmargin: 1rem 0 0;\r\n\t\t\t\t}\r\n\r\n\t\t\t\th4 {\r\n\t\t\t\t\tfont-size: 0.9rem;\r\n\t\t\t\t\tfont-weight: 400;\r\n\t\t\t\t\tline-height: 1.5;\r\n\t\t\t\t\tcolor: #191a1a;\r\n\t\t\t\t\tmargin: 1rem 0 0;\r\n\r\n\t\t\t\t\t&.thankyouHeading {\r\n\t\t\t\t\t\tdisplay: block;\r\n\r\n\t\t\t\t\t\tspan {\r\n\t\t\t\t\t\t\tcolor: #84bd00;\r\n\t\t\t\t\t\t}\r\n\r\n\t\t\t\t\t\tspan,\r\n\t\t\t\t\t\tstrong {\r\n\t\t\t\t\t\t\tdisplay: block;\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\r\n\t\t\t\tp {\r\n\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\talign-items: center;\r\n\t\t\t\t\tjustify-content: center;\r\n\r\n\t\t\t\t\tmargin: 1rem 0 0;\r\n\r\n\t\t\t\t\tspan {\r\n\t\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\t\talign-items: center;\r\n\t\t\t\t\t\tjustify-content: center;\r\n\r\n\t\t\t\t\t\tfont-size: 0.8rem;\r\n\t\t\t\t\t\tfont-weight: 700;\r\n\t\t\t\t\t\tline-height: 1;\r\n\t\t\t\t\t\tcolor: #0f61dc;\r\n\t\t\t\t\t\tbackground-color: rgba(#2056a5, 0.12);\r\n\t\t\t\t\t\tborder-radius: 1.5rem;\r\n\t\t\t\t\t\tpadding: 0.75rem 3rem;\r\n\r\n\t\t\t\t\t\ti {\r\n\t\t\t\t\t\t\tfont-size: 1rem;\r\n\t\t\t\t\t\t\tmargin-right: 0.5rem;\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\r\n\t\t\t\t\ta {\r\n\t\t\t\t\t\tdisplay: inline-block;\r\n\t\t\t\t\t\tpadding: 0.6rem 3rem;\r\n\r\n\t\t\t\t\t\ti {\r\n\t\t\t\t\t\t\tmargin-right: 0.5rem;\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\r\n\t\t\t\t\tbutton {\r\n\t\t\t\t\t\tdisplay: inline-block;\r\n\t\t\t\t\t\tpadding: 0.6rem 3rem;\r\n\r\n\t\t\t\t\t\ti {\r\n\t\t\t\t\t\t\tmargin-right: 0.5rem;\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t#{$signUpPage}__form {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\tflex-direction: column;\r\n\r\n\t\t\t\twidth: 100%;\r\n\r\n\t\t\t\t@media (max-width: $desktop - 1) {\r\n\t\t\t\t\twidth: 60%;\r\n\t\t\t\t\tmargin: 0 auto;\r\n\t\t\t\t}\r\n\r\n\t\t\t\t@media (max-width: $mobileBig) {\r\n\t\t\t\t\twidth: 100%;\r\n\t\t\t\t}\r\n\r\n\t\t\t\t#{$signUpPage}__formSection {\r\n\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\tflex-direction: column;\r\n\r\n\t\t\t\t\tpadding-left: 0.75rem;\r\n\t\t\t\t\tpadding-right: 0.75rem;\r\n\r\n\t\t\t\t\t> .row {\r\n\t\t\t\t\t\t> [class*=\"col-\"] {\r\n\t\t\t\t\t\t\t&:last-child {\r\n\t\t\t\t\t\t\t\t.form-group {\r\n\t\t\t\t\t\t\t\t\tmargin: 0;\r\n\t\t\t\t\t\t\t\t}\r\n\t\t\t\t\t\t\t}\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\r\n\t\t\t\t\t.form-group {\r\n\t\t\t\t\t\tmargin: 0 0 1rem;\r\n\t\t\t\t\t\tposition: relative;\r\n\r\n\t\t\t\t\t\t.css-qbdosj-Input{margin: 0;padding: 0;}\r\n\t\t\t\t\t\t.css-13cymwt-control{\r\n\t\t\t\t\t\t\tborder-radius: 0.375rem;min-height: 27px;\r\n\r\n\t\t\t\t\t\t\t.css-1xc3v61-indicatorContainer{padding: 0.215rem !important;}\t\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t\t.css-1jqq78o-placeholder{margin: 0;font-size: 0.8rem;color:#191a1a;}\r\n\t\t\t\t\t\t.css-1fdsijx-ValueContainer{padding: 0.4rem 0.9rem !important;font-size: 1rem !important;}\r\n\t\t\t\t\t\t@media screen and (min-width: $tabletSmall) and (max-width: $desktopSmall) {\r\n\t\t\t\t\t\t\t.css-1fdsijx-ValueContainer{padding: 0.4rem 0.9rem !important;font-size: 0.8rem !important;}\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t\t.css-1dimb5e-singleValue{font-size: 0.8rem;}\r\n\t\t\t\t\t\t.css-t3ipsp-control{\r\n\t\t\t\t\t\t\tborder-radius: 0.375rem;min-height: 27px;\r\n\r\n\t\t\t\t\t\t\t.css-15lsz6c-indicatorContainer{padding: 0.215rem !important;}\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t\t\r\n\r\n\r\n\t\t\t\t\t\t&.withIcon {\r\n\t\t\t\t\t\t\t.form-control {\r\n\t\t\t\t\t\t\t\tpadding: 0.6rem 0.9rem;\r\n\t\t\t\t\t\t\t\tborder-radius: 0.375rem;\r\n\t\t\t\t\t\t\t\tpadding-right: 2.5rem;\r\n\t\t\t\t\t\t\t}\r\n\r\n\t\t\t\t\t\t\t.passwordToggle {\r\n\t\t\t\t\t\t\t\tdisplay: block;\r\n\t\t\t\t\t\t\t\tposition: absolute;\r\n\t\t\t\t\t\t\t\ttop: 1.2rem;\r\n\t\t\t\t\t\t\t\tright: 0.75rem;\r\n\t\t\t\t\t\t\t\twidth: 1.25rem;\r\n\t\t\t\t\t\t\t\ttransform: translateY(-50%);\r\n\r\n\t\t\t\t\t\t\t\timg {\r\n\t\t\t\t\t\t\t\t\twidth: 100%;\r\n\t\t\t\t\t\t\t\t}\r\n\t\t\t\t\t\t\t}\r\n\r\n\t\t\t\t\t\t\t&--forgetPassword {\r\n\t\t\t\t\t\t\t\t.form-control {\r\n\t\t\t\t\t\t\t\t\tborder-radius: 0.375rem;\r\n\t\t\t\t\t\t\t\t\tpadding: 0.6rem 0.9rem 0.6rem 0.6rem !important;\r\n\t\t\t\t\t\t\t\t\t// padding-left: 2.5rem !important;\r\n\t\t\t\t\t\t\t\t}\r\n\r\n\t\t\t\t\t\t\t\t.passwordToggle {\r\n\t\t\t\t\t\t\t\t\tdisplay: block;\r\n\t\t\t\t\t\t\t\t\tposition: absolute;\r\n\t\t\t\t\t\t\t\t\ttop: 0.7rem;\r\n\t\t\t\t\t\t\t\t\tleft: 0.75rem;\r\n\t\t\t\t\t\t\t\t\twidth: 1.25rem;\r\n\r\n\t\t\t\t\t\t\t\t\timg {\r\n\t\t\t\t\t\t\t\t\t\twidth: 100%;\r\n\t\t\t\t\t\t\t\t\t}\r\n\t\t\t\t\t\t\t\t}\r\n\t\t\t\t\t\t\t}\r\n\t\t\t\t\t\t}\r\n\r\n\t\t\t\t\t\tlabel {\r\n\t\t\t\t\t\t\tfont-size: 0.8rem;\r\n\t\t\t\t\t\t\tfont-weight: 600;\r\n\t\t\t\t\t\t\tline-height: 1.5;\r\n\t\t\t\t\t\t\tcolor: #191a1a;\r\n\t\t\t\t\t\t\tmargin: 0 0 0.5rem;\r\n\t\t\t\t\t\t}\r\n\r\n\t\t\t\t\t\t.form-control {\r\n\t\t\t\t\t\t\tborder-radius: 0.375rem;\r\n\t\t\t\t\t\t\tfont-size: 0.8rem;\r\n\t\t\t\t\t\t\tfont-weight: 400;\r\n\t\t\t\t\t\t\tline-height: 1.5;\r\n\t\t\t\t\t\t\tletter-spacing: 0.025rem;\r\n\t\t\t\t\t\t\tcolor: #191a1a;\r\n\t\t\t\t\t\t\tpadding: 0.5rem 0.75rem;\r\n\t\t\t\t\t\t\tmin-height: 2.25rem;\r\n\t\t\t\t\t\t\tbackground-color: $primary-bgColor;\r\n\r\n\t\t\t\t\t\t\t&::-webkit-input-placeholder {\r\n\t\t\t\t\t\t\t\tfont-size: 0.8rem;\r\n\t\t\t\t\t\t\t\tfont-weight: 400;\r\n\t\t\t\t\t\t\t\tline-height: 1.5;\r\n\t\t\t\t\t\t\t\tletter-spacing: 0.025rem;\r\n\t\t\t\t\t\t\t\tcolor: #191a1a;\r\n\t\t\t\t\t\t\t}\r\n\r\n\t\t\t\t\t\t\t&::-moz-placeholder {\r\n\t\t\t\t\t\t\t\tfont-size: 0.8rem;\r\n\t\t\t\t\t\t\t\tfont-weight: 400;\r\n\t\t\t\t\t\t\t\tline-height: 1.5;\r\n\t\t\t\t\t\t\t\tletter-spacing: 0.025rem;\r\n\t\t\t\t\t\t\t\tcolor: #191a1a;\r\n\t\t\t\t\t\t\t}\r\n\r\n\t\t\t\t\t\t\t&:-ms-input-placeholder {\r\n\t\t\t\t\t\t\t\tfont-size: 0.8rem;\r\n\t\t\t\t\t\t\t\tfont-weight: 400;\r\n\t\t\t\t\t\t\t\tline-height: 1.5;\r\n\t\t\t\t\t\t\t\tletter-spacing: 0.025rem;\r\n\t\t\t\t\t\t\t\tcolor: #191a1a;\r\n\t\t\t\t\t\t\t}\r\n\r\n\t\t\t\t\t\t\t&:-moz-placeholder {\r\n\t\t\t\t\t\t\t\tfont-size: 0.8rem;\r\n\t\t\t\t\t\t\t\tfont-weight: 400;\r\n\t\t\t\t\t\t\t\tline-height: 1.5;\r\n\t\t\t\t\t\t\t\tletter-spacing: 0.025rem;\r\n\t\t\t\t\t\t\t\tcolor: #191a1a;\r\n\t\t\t\t\t\t\t}\r\n\r\n\t\t\t\t\t\t\t&:focus {\r\n\t\t\t\t\t\t\t\tbox-shadow: none;\r\n\t\t\t\t\t\t\t}\r\n\t\t\t\t\t\t}\r\n\r\n\t\t\t\t\t\t> p {\r\n\t\t\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\t\t\talign-items: center;\r\n\t\t\t\t\t\t\tjustify-content: flex-start;\r\n\r\n\t\t\t\t\t\t\tfont-size: 0.8rem;\r\n\t\t\t\t\t\t\tfont-weight: 600;\r\n\t\t\t\t\t\t\tline-height: 1.5;\r\n\t\t\t\t\t\t\tcolor: #191a1a;\r\n\t\t\t\t\t\t\tmargin: 0;\r\n\r\n\t\t\t\t\t\t\t&.text-end {\r\n\t\t\t\t\t\t\t\tjustify-content: flex-end;\r\n\t\t\t\t\t\t\t}\r\n\r\n\t\t\t\t\t\t\tinput {\r\n\t\t\t\t\t\t\t\tmargin: 0 0.5rem 0 0;\r\n\t\t\t\t\t\t\t}\r\n\r\n\t\t\t\t\t\t\ta {\r\n\t\t\t\t\t\t\t\tdisplay: inline-block;\r\n\t\t\t\t\t\t\t\tfont-size: 0.8rem;\r\n\t\t\t\t\t\t\t\tfont-weight: 600;\r\n\t\t\t\t\t\t\t\tline-height: 1.5;\r\n\t\t\t\t\t\t\t\tcolor: $primary-color;\r\n\t\t\t\t\t\t\t\tmargin-left: 0.25rem;\r\n\t\t\t\t\t\t\t}\r\n\t\t\t\t\t\t}\r\n\r\n\t\t\t\t\t\t// .textValidatorError {\r\n\t\t\t\t\t\t// \tdisplay: flex;\r\n\t\t\t\t\t\t// \tflex-wrap: wrap;\r\n\r\n\t\t\t\t\t\t// \tmargin-top: 0.5rem;\r\n\r\n\t\t\t\t\t\t// \tp {\r\n\t\t\t\t\t\t// \t\tfont-size: 0.8rem;\r\n\t\t\t\t\t\t// \t\tfont-weight: 700;\r\n\t\t\t\t\t\t// \t\tline-height: 1.5;\r\n\t\t\t\t\t\t// \t\tcolor: #191a1a;\r\n\t\t\t\t\t\t// \t\tmargin: 0 0 0.5rem;\r\n\t\t\t\t\t\t// \t\twidth: 100%;\r\n\t\t\t\t\t\t// \t}\r\n\r\n\t\t\t\t\t\t// \tul {\r\n\t\t\t\t\t\t// \t\tdisplay: flex;\r\n\t\t\t\t\t\t// \t\tflex-wrap: wrap;\r\n\r\n\t\t\t\t\t\t// \t\tmargin: 0;\r\n\t\t\t\t\t\t// \t\tpadding: 0;\r\n\r\n\t\t\t\t\t\t// \t\tli {\r\n\t\t\t\t\t\t// \t\t\tdisplay: block;\r\n\t\t\t\t\t\t// \t\t\tfont-size: 0.7rem;\r\n\t\t\t\t\t\t// \t\t\tfont-weight: 700;\r\n\t\t\t\t\t\t// \t\t\tline-height: 1.5;\r\n\t\t\t\t\t\t// \t\t\tcolor: #8b8c8c;\r\n\t\t\t\t\t\t// \t\t\tmargin: 0 0 0.5rem;\r\n\r\n\t\t\t\t\t\t// \t\t\twidth: 50%;\r\n\r\n\t\t\t\t\t\t// \t\t\t&:nth-last-child(1),\r\n\t\t\t\t\t\t// \t\t\t&:nth-last-child(2) {\r\n\t\t\t\t\t\t// \t\t\t\tmargin-bottom: 0;\r\n\t\t\t\t\t\t// \t\t\t}\r\n\r\n\t\t\t\t\t\t// \t\t\tspan {\r\n\t\t\t\t\t\t// \t\t\t\tdisplay: block;\r\n\r\n\t\t\t\t\t\t// \t\t\t\t&.passwordAdded {\r\n\t\t\t\t\t\t// \t\t\t\t\tcolor: #50bc14;\r\n\t\t\t\t\t\t// \t\t\t\t}\r\n\t\t\t\t\t\t// \t\t\t}\r\n\t\t\t\t\t\t// \t\t}\r\n\t\t\t\t\t\t// \t}\r\n\t\t\t\t\t\t// }\r\n\r\n\t\t\t\t\t\t.signup_checklabel{\r\n\t\t\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\t\t\talign-items: center;\r\n\r\n\t\t\t\t\t\t\tinput{\r\n\t\t\t\t\t\t\t\tmargin-right: 0.5rem;\r\n\t\t\t\t\t\t\t\twidth: 20px;\r\n\t\t\t\t\t\t\t\theight: 20px;\r\n\t\t\t\t\t\t\t}\r\n\r\n\t\t\t\t\t\t\tp{\r\n\t\t\t\t\t\t\t\tmargin-bottom: 0;\r\n\t\t\t\t\t\t\t}\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
